export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const headerHeight = 80; // Account for fixed header
    const elementPosition = element.offsetTop - headerHeight;
    
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }
};

export const handleNavClick = (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
  event.preventDefault();
  scrollToSection(sectionId);
};